import { render, staticRenderFns } from "./ModalNewInvoice.vue?vue&type=template&id=2a83c290&"
import script from "./ModalNewInvoice.vue?vue&type=script&lang=js&"
export * from "./ModalNewInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports